import { getCompanyTextColor } from '../../../../utils';
import RemoveIcon from '../../../../assets/img/gantt/X.png';
import { UI_ELEMENTS } from './utils';

const DEFAULT_ICON_SIZE = 14;

const getTagSvg = (textColor, size = DEFAULT_ICON_SIZE) => `
  <svg width="${size}" viewBox="0 0 16 16" fill="${textColor}">
    <path d="M0.409302 5.87389V1.23607C0.444715 0.527453 1.01572 0.00853333 1.64537 0H6.28318C7.02902 0.0463467 7.91953 0.33876 8.39779 0.878533L15.2626 8.51972C15.6938 9.06561 15.706 9.82104 15.2626 10.2768L9.88925 15.6501C9.3624 16.1267 8.57631 16.1065 8.13219 15.6501L1.28782 7.98849C0.788875 7.39925 0.416182 6.61145 0.409302 5.87389ZM2.42174 3.19744C2.45098 3.88691 2.99486 4.38449 3.60674 4.39265C4.2982 4.36177 4.79378 3.81064 4.80196 3.19744C4.77152 2.50567 4.21757 2.02047 3.60674 2.01244C2.91694 2.04125 2.42973 2.58795 2.42174 3.19744Z"></path>
  </svg>
`;

const renderRemoveBtn = (t) => `
  <div class="remove-option-tag-custom">
    <div class="remove-tag-x">
      <img width="10" src="${RemoveIcon}" alt="Remove icon" />
    </div>
    <div class="remove-tag-text">${t('remove_tag_label')}</div>
  </div>
`;

const renderTagToSelect = (option) => {
  const { description, name } = option;
  const textColor = getCompanyTextColor(description);

  return `
    <div class="item-gantt">
      <div
        class="tag-border cut-text-and-dot tag-item-select"
        style="color: ${textColor}; background-color: ${description}">
        ${getTagSvg(textColor)}
        <span class="tag-name" title="${name}">${name}</span>
      </div>
    </div>
  `;
};

const extractColorFromDescription = (description) => {
  if (!description) return '#000000';
  const colorMatch = description.match(/#[0-9a-fA-F]{6}/);
  return colorMatch ? colorMatch[0] : description;
};

export const renderSelectedOption = (tags, column) => {
  if (!tags || !tags.length) {
    return `
      <div class="selected-option-container">
        <div class="empty-selection">
          <div class="plus-icon-container"></div>
        </div>
      </div>
    `;
  }

  return `
    <div class="selected-option-container" style="width: ${column?.width}px;">
      ${tags
        .map((tag) => {
          const { description, name } = tag;
          const backgroundColor = extractColorFromDescription(description);
          const textColor = getCompanyTextColor(backgroundColor);

          return `
            <div class="tag-selection-container" style="width: ${column?.width}px;">
              <div
                class="tag-outbuild"
                style="background-color: ${backgroundColor}; color: ${backgroundColor};">
                <div class="tag-content-container">
                  <span
                    class="tag-dot-custom-field"
                    style="background-color: ${backgroundColor}; border: 1px solid ${textColor};">
                  </span>
                  <span
                    class="tag-name-custom-field cut-text-and-dot"
                    title="${name}"
                    style="color: ${textColor};">
                    ${name}
                  </span>
                </div>
              </div>
            </div>
          `;
        })
        .join('')}
    </div>
  `;
};

export const createPlaceholderHtml = (
  columnName,
  objectId,
  selectedTags,
  column
) => {
  const innerContent =
    selectedTags.length > 0
      ? renderSelectedOption(selectedTags, column)
      : UI_ELEMENTS.EMPTY_SELECTION;

  return `<div id="tags-placeholder-container-${columnName}-${objectId}">
    <div id="tags-placeholder-${columnName}-${objectId}">
      ${innerContent}
    </div>
  </div>`;
};

export const createOptionsListHtml = (optionsList, selectedTags = []) =>
  optionsList
    .map((option) => {
      const isSelected = selectedTags.some(
        (tag) => String(tag.id) === String(option.id)
      );
      return `
    <li class="dropdown-option ${isSelected ? 'selected-option' : ''}" style="cursor: pointer; list-style: none;"
        data-action="tagSelection" data-value="${option.id}-${option.name}-${option.description}">
      ${renderTagToSelect(option)}
    </li>
  `;
    })
    .join('');

export const createButtonHtml = (t) => `
  <button type="create-tag-btn" class="create-option" data-action="tagCreate">
    + ${t('new_tag')}
  </button>
`;

export const removeButtonHtml = (t) => `
    <button type="remove-tag-btn" class="remove-option" data-action="tagRemove">
      ${renderRemoveBtn(t)}
    </button>
  `;
